import declare from "dojo/_base/declare";
import Widget from "csi/form/Widget";
import locale from "csi/locale";
import { getDateTime } from "csi/utility/dateUtility";
import Query from "csi/xml/Query";
import xml from "csi/xml";
import Values from "csi/store/Values";

const CLArchiveFormController = declare(Widget, {
	/** @property {Field} toDate */
	toDate: null,
	/** @property {Field} fromDate */
	fromDate: null,
	/** @property {Field} c8Object */
	c8Object: null,

	_onValidateToDate: function () {
		if (this.toDate.getValue() > getDateTime()) { throw new Error(locale.resource("ToDateAfterToday")); };
	},
	_onValidateFromDate: function () {
		if (this.toDate.getValue() != "0") {
			if (this.fromDate.getValue() > this.toDate.getValue()) {
				throw new Error(locale.resource("FromDateAfterToDate"));
			};
		}
	},
	/**
	 * @override
	 * Create store list of tracked object for C8Object dropdown
	 */
	getFieldStore(field, value) {
		const type = "DomainClassConfiguration";
		const q = new Query().Type(type)
			.Attr("ChangeTrackingEnabled", xml.OP_EQUALS, true);
		const store = new Values({
			filterQuery: q,
		});
		if (field === this.c8Object) {
			return store;
		}
		return this.inherited(arguments);
	},
	/**
	 * @override
	 */
	_resolveView(): void {
		this.inherited(arguments);

		this.toDate = this.getField("ToDate");
		this.fromDate = this.getField("FromDate");
		this.c8Object = this.getField("C8Object");

		this.toDate.m_onValidate = "_onValidateToDate";
		this.fromDate.m_onValidate = "_onValidateFromDate";
	},
});

export = CLArchiveFormController;

